<div class="min-h-screen flex flex-col">
  <div class="py-3 px-5 h-18 flex border-b-white border-b mb-11">
    <a class="bg-rocket-logo size-12 hover:scale-105" [routerLink]="['/']" title="RocketKOR Admin Portal"></a>
  </div>

  <div>
    @for (menuItem of menuItems; track menuItem.title) {
      <div class="mt-5 mx-3 first:mt-0">
        <a
          class="flex h-12 cursor-pointer items-center pl-4 text-white gap-3 rounded-lg opacity-70 hover:opacity-100"
          [title]="menuItem.title"
          routerLinkActive="!opacity-100 bg-white/10"
          [routerLink]="menuItem.href"
        >
          <rkt-icon class="text-2xl" [name]="menuItem.icon"></rkt-icon>
          <span class="text-sm font-semibold">{{ menuItem.title }}</span>
        </a>
      </div>
    }
  </div>

  <app-version class="mt-auto px-5 pb-6 text-xs text-white opacity-70" />
</div>
